import {
  DeleteAbout,
  DeleteAboutPicture,
  UpdateAbout,
} from "../../redux/about";
import { useDispatch, useSelector } from "react-redux";

import { AboutForm } from "./AboutForm";
import { ErrorBanner } from "../../components/banner";
import { IoTrash } from "react-icons/io5";
import { Loading } from "../../components/loader";
import { Section } from "../../components/section";
import { Text } from "../../components/typography";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const AboutEdit = () => {
  const dispatch = useDispatch();
  const { state } = useLocation();
  let navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.about);

  const onFormSubmit = (values) => {
    if (window.confirm(`Are you sure you want to save your edits?`)) {
      dispatch(UpdateAbout(state.about.id, values));
    }
    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about");
      }, 500);
    }
  };

  const onDeleteSubmit = () => {
    if (window.confirm(`Are you sure you want to delete this?`)) {
      dispatch(DeleteAbout(state.about));
    }
    if (!loading && !error) {
      setTimeout(() => {
        navigate("/about");
      }, 1000);
    }
  };

  const onHandleImageDelete = (mediaSource, fileName) => {
    dispatch(DeleteAboutPicture(mediaSource, fileName));
  };

  const InitialValues = {
    ...state.about,
    files: state?.about?.media?.mediaFiles,
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <Section>
      <SubNav>
        <li onClick={onDeleteSubmit}>
          <IoTrash />
          <Text>Delete</Text>
        </li>
      </SubNav>
      {error && <ErrorBanner text={error} />}
      <AboutForm
        initialValues={InitialValues}
        onFormSubmit={onFormSubmit}
        onHandleImageDelete={onHandleImageDelete}
      />
    </Section>
  );
};

const SubNav = styled.nav`
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: 2rem;

  li {
    margin-left: 1.5rem;
    display: flex;
    align-items: center;
    color: red;

    p {
      margin: 0;
      padding: 0 0 0 0.5rem;
      color: red;
    }

    &:hover {
      cursor: pointer;
    }
  }
`;
